var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CounterDisplay"},[_c('Picture',{attrs:{"name":_vm.icon}}),_c('span',{staticClass:"Number",domProps:{"textContent":_vm._s(_vm.value)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }